<template>
    <div class="posts">
        <post-back :title="tr.latest_publications" />
        <div class="containers posts-container">
            <posts-grid :posts="posts" :total="total" />
        </div>
    </div>
</template>
<script>
import PostsGrid from "./posts-grid.vue";
export default {
    components: { PostsGrid },
    name: 'posts',
    computed: {
        posts() {
            let { lang } = this.$store.state;
            console.log(lang);
            return this.$store.getters.publications.filter(p => { return p.content[lang]&&p.content[lang].enabled });
        },
        total() { let { lang } = this.$store.state; return this.$store.getters.publications.filter(p => { return p.content[lang].enabled }).length; },
        tr() { return this.$store.getters.translates; },
        seo() {
            return { 
              title: this.trRaw.latest_publications,
              description: this.trRaw.latest_publications_meta_description
            }
        }
    }
}
</script>
<style lang="css" scoped>
.posts-container {
    padding: 30px 0;
}
</style>